import makeCall from "../services/api"

// import makeCall, { host } from '../services/api'
export default {
    state: {
        dataStore: {}
    },
    mutations: {
        clearExtraDataState(state) {
            state.dataStore = {}
        },
        updateDataStore: function (state, payload) {
            const { key, value } = payload
            state.dataStore = {
                ...state.dataStore,
                [key]: value
            }
        }
    },
    actions: {
        loadSataStoreData: async function ({ state, commit }, payload) {
            const { dataStore } = state
            const { key, url } = payload
            // url temp
            if (!dataStore[key] || url) {
                const response = await makeCall({ url })
                if (response && response.data) {
                    commit('updateDataStore', { key, value: response.data })
                }
            }
        }
    },
    getters: { 
        dataStore: function (state) {
            return state.dataStore
        } 
    }
}